export function TabletRotateMessage() {
  return (
    <section className="shift-tablet-rotate-message" role="alert" aria-live="assertive">
      <h1>Tableti yatay çevirin</h1>
      <p>Vardiya üretim formu tabletlerde yatay kullanım için hazırlanmıştır.</p>
    </section>
  );
}
